module.exports = " <div v-show=show transition=vux-popup :style={height:height} class=vux-popup> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/popup/index.vue
// module id = 235
// module chunks = 2